import React from 'react';
import './Card.css';

const Card = ({mainText,subText,bodyText,photoUrl,children,scale}) => {
    if(!scale)  scale = 1;
    return (
        <div  className='shadowCss parentCard' style={{display:'flex',position:'relative',flexDirection:'column',alignItems:'center',justifyContent:'center',maxWidth:`${scale*230}px`,minWidth:`${scale*230}px`,padding:'10px 20px',borderRadius:'10px',margin:'20px 20px',cursor:'pointer',minHeight:`${scale*300}px`,transition:'all .3s ease-in-out',backgroundColor:'white',}}>
            <div style={{position:'absolute',top:'0px',zIndex:1,width:'100%',}}>
                {/* <img src={photoUrl} alt='' style={{width:'110px',height:'110px',marginTop:'25px',borderRadius:'50%',objectFit:'cover',zIndex:1,borderColor:'white',borderWidth:'5px',cursor:'pointer',animation:'all 0.4s ease-in-out'}} />  */}
                <div className='cardAvatarImage' style={{'--scale':scale,}}>
                    <img src={photoUrl} alt='' style={{width:'100%',height:'100%',objectFit:'cover',zIndex:1,}} /> 
                </div>
            </div>
            <img src={photoUrl} alt='' style={{width:'100%',objectFit:'cover',height:`${scale*90}px`,position:'absolute',top:'0px',borderTopLeftRadius:'10px',borderTopRightRadius:'10px',filter:'blur(2px)',zIndex:0,}} />
            <div className='cardFadeBackground'>
                <div className='cardMainText' style={{color:'rgba(0,0,0,0.9)',fontSize:'1rem',marginTop:`${scale*120}px`,textAlign:'center',transition:'all .3s ease-in-out'}}>{mainText}</div>
                <div className='cardSubText text-blue-500' style={{fontWeight:'600',fontSize:'0.8rem',textAlign:'center',transition:'all .3s ease-in-out'}} >{subText}</div>
                <div className='cardBodyText' style={{color:'rgba(0,0,0,0.7)',fontSize:'.8rem',marginTop:'5px',textAlign:'center',transition:'all .3s ease-in-out'}}>{bodyText}</div>
            </div>
            {children}
        </div>
    );
};

export default Card;